import { PartnerApplicationsView } from "@/components/partner/PartnerViews";

const PartnerApplications = () => <PartnerApplicationsView />;

export default PartnerApplications;
